<script lang="ts" setup>
export interface PagebuilderContactUsProps {
    data: WizardData[]
}

const props = defineProps<PagebuilderContactUsProps>()
const wizardModalData = ref<WizardData | null>()
const attrs = useAttrs()
</script>

<template>
  <div
    v-bind="attrs"
    class="row g-6"
  >
    <div
      v-for="(item, index) in props.data"
      :key="`weus-${index}`"
      class="col-12 col-md-6 col-lg-4"
    >
      <WidgetEmailUsItem
        :item="item"
        @select="(data: WizardData) => wizardModalData = data"
      />
    </div>
  </div>

  <Modal
    v-if="wizardModalData"
    :is-open="Boolean(wizardModalData)"
    size="xxl"
    @close="wizardModalData = null"
  >
    <Tracker :data="{ position: wizardModalData.title }">
      <WidgetWizard :data="wizardModalData" />
    </Tracker>
  </Modal>
</template>
